import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import("@/views/HomeView.vue"),
  },
  {
    path: '/labeling',
    name: 'labeling',
    component: () => import("@/views/labelingView/index.vue"),
  },
  {
    path: '/labeling/edit',
    name: 'labelingEdit',
    component: () => import("@/views/LabelingEditView.vue"),
  },
  {
    path: '/review',
    name: 'review',
    component: () => import("@/views/reviewView/index.vue"),
  },
  {
    path: '/review/edit',
    name: 'reviewEdit',
    component: () => import("@/views/ReviewEditView.vue"),
  },
  {
    path: '/export',
    name: 'export',
    component: () => import("@/views/ExportView.vue"),
  },
  {
    path: '/export/browse',
    name: 'exportBrowse',
    component: () => import("@/views/ExportBrowse.vue"),
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import("@/views/AuthView.vue")
  },
  {
    path: '/dataBoard',
    name: 'dataBoard',
    component: () => import("@/views/DataBoardView.vue")
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
